import { useEffect } from 'react'
import { useUiStore } from '@/stores/uiStore'
import { useMediaQuery } from './useMediaQuery'

/** Applies the stored theme preference (light/dark/system) to <html>. */
export function useApplyTheme(): void {
  const theme = useUiStore((s) => s.theme)
  const systemDark = useMediaQuery('(prefers-color-scheme: dark)')
  const dark = theme === 'dark' || (theme === 'system' && systemDark)

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark)
  }, [dark])
}
